<template>
  <logo-layout 
    :title="$t('pages.incrustado.error')"
    :description="description"
  />
</template>

<script>
export default {
  computed: {
    description () {
      switch (window.errorUsuarioComercial) {
        case 0:
          return this.getTexto('error.generico')
        case 1:
          return this.$t('pages.incrustado.mensajeErrorUsuarioComercial', {usuarioComercial: this.usuarioComercial})
        case 2:
          return this.$t('pages.incrustado.mensajeErrorUsuarioComercialPromocion', {usuarioComercial: this.usuarioComercial, codigoPromocion: window.codigoPromocion})
        case 3:
          return this.$t('pages.incrustado.mensajeErrorUsuarioComercialInactivo', {usuarioComercial: this.usuarioComercial})
        default:
          return this.getTexto('error.generico')
      }
    },
    usuarioComercial () {
      if (window.usuarioComercial != 0) {
        return window.usuarioComercial.usuario != null ? (' ' + window.usuarioComercial.usuario) : ''
      }
      return ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/incrustado/mensajeError.vue